import { OrderMeasuresTypes } from '../enums';

/** Who performed an auditable action on a service type, and when. */
export interface IServiceTypeAudit {
    userId?: string;
    userName?: string;
    timestamp: string;
}

export interface ICreateServiceTypeDto {
    /** Unique per organization. Not editable once created. */
    code: string;
    name: string;
    /** The "service": a trip definition this service type belongs to. */
    tripDefinition: string;
    /** Deprecated: trips take their unit from the global list. */
    allowedMeasureUnits?: OrderMeasuresTypes[];
    /** Preloaded when the service is picked on a trip. A measure unit code of the organization. */
    defaultMeasureUnit?: string | null;
}

/** `code` is intentionally excluded: it cannot be changed after creation. */
export type IUpdateServiceTypeDto = Partial<Omit<ICreateServiceTypeDto, 'code'>>;

export interface IServiceTypeOutputDto {
    id: string;
    code: string;
    name: string;
    tripDefinition: string;
    allowedMeasureUnits?: OrderMeasuresTypes[];
    defaultMeasureUnit?: string | null;
    createdBy?: IServiceTypeAudit;
    updatedBy?: IServiceTypeAudit;
    deletedBy?: IServiceTypeAudit;
    createdAt?: string;
    updatedAt?: string;
}

/** What a trip exposes when its service type is populated: no audit trail. */
export type IServiceTypeSummaryDto = Omit<IServiceTypeOutputDto, 'createdBy' | 'updatedBy' | 'deletedBy'>;

/** One service billed on a trip. Unit and quantity are optional and the unit is not restricted by the service type. */
export interface ITripServiceDto {
    serviceType: string;
    /** A measure unit code of the organization. */
    measureUnit?: string;
    quantity?: number;
}

export interface ITripServiceOutputDto extends Omit<ITripServiceDto, 'serviceType'> {
    serviceType: string | IServiceTypeSummaryDto;
}
